import axios from 'axios'

import config from '../../config'
import createAsyncConst from '../../util/createAsyncConst'
import action, { actionFailed } from '../../util/action'

export const SYNC_NFSE_CONFIG = createAsyncConst('SYNC_NFSE_CONFIG')
export const SHOW_NFSEN_CONFIG = createAsyncConst('SHOW_NFSEN_CONFIG')
export const STORE_NFSEN_CONFIG = createAsyncConst('STORE_NFSEN_CONFIG')

export const fetchViaCep = async cep => {
  // Instância limpa: sem o interceptor global (X-Socket-ID) e sem o header
  // Authorization, que disparariam um preflight OPTIONS bloqueado pelo ViaCEP.
  const viaCepClient = axios.create()
  delete viaCepClient.defaults.headers.common.Authorization

  const resp = await viaCepClient
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then(response => response?.data)

  return resp
}

export const fetchCnpjInfo = async cnpj => {
  const resp = await axios
    .get(`${config.API_URL}/consult-cnpj`, {
      params: {
        cnpj,
      },
    })
    .then(response => response?.data)

  return resp
}

export const store = async formData => {
  const resp = await axios
    .post(`${config.API_URL}/laundry-eletronic-invoice`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => response?.data)

  return resp
}

export const update = async formData => {
  const resp = await axios
    .post(`${config.API_URL}/laundry-eletronic-invoice/update`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => response?.data)

  return resp
}

export const show = async () => {
  const resp = await axios
    .get(`${config.API_URL}/laundry-eletronic-invoice`)
    .then(response => response?.data)

  return resp
}

export const showNfseConfig = async () => {
  const resp = await axios
    .get(`${config.API_URL}/laundry-nfse-config`)
    .then(response => response?.data)

  return resp
}

export const storeNfseConfig = async formData => {
  const resp = await axios
    .post(`${config.API_URL}/laundry-nfse-config`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => response?.data)

  return resp
}

export const indexNfseEnquadramento = async () => {
  const resp = await axios
    .get(`${config.API_URL}/laundry-nfse-enquadramento`)
    .then(response => response?.data)

  return resp
}

export const storeNfseEnquadramento = async data => {
  const resp = await axios
    .post(`${config.API_URL}/laundry-nfse-enquadramento`, data)
    .then(response => response?.data)

  return resp
}

export const updateNfseEnquadramento = async (id, data) => {
  const resp = await axios
    .put(`${config.API_URL}/laundry-nfse-enquadramento/${id}`, data)
    .then(response => response?.data)

  return resp
}

export const destroyNfseEnquadramento = async id => {
  const resp = await axios
    .delete(`${config.API_URL}/laundry-nfse-enquadramento/${id}`)
    .then(response => response?.data)

  return resp
}

export const indexNfsenEnquadramento = async () => {
  const resp = await axios
    .get(`${config.API_URL}/laundry-nfsen-enquadramento`)
    .then(response => response?.data)

  return resp
}

export const storeNfsenEnquadramento = async data => {
  const resp = await axios
    .post(`${config.API_URL}/laundry-nfsen-enquadramento`, data)
    .then(response => response?.data)

  return resp
}

export const updateNfsenEnquadramento = async (id, data) => {
  const resp = await axios
    .put(`${config.API_URL}/laundry-nfsen-enquadramento/${id}`, data)
    .then(response => response?.data)

  return resp
}

export const destroyNfsenEnquadramento = async id => {
  const resp = await axios
    .delete(`${config.API_URL}/laundry-nfsen-enquadramento/${id}`)
    .then(response => response?.data)

  return resp
}

export function syncNationalNfse(active) {
  return dispatch => {
    dispatch(action(SYNC_NFSE_CONFIG.ACTION, {}))
    return axios
      .post(`${config.API_URL}/sync-national-nfse`, { active })
      .then(resp => {
        return resp.data.data
      })
      .then(data => dispatch(action(SYNC_NFSE_CONFIG.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(SYNC_NFSE_CONFIG, e)))
  }
}

export function showNfsenConfig() {
  return dispatch => {
    dispatch(action(SHOW_NFSEN_CONFIG.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-nfsen-config`)
      .then(resp => {
        dispatch(action(SHOW_NFSEN_CONFIG.SUCCESS, { data: resp.data }))
        return resp.data
      })
      .catch(e => dispatch(actionFailed(SHOW_NFSEN_CONFIG, e)))
  }
}

export function storeNfsenConfig(data) {
  return dispatch => {
    dispatch(action(STORE_NFSEN_CONFIG.ACTION))
    return axios
      .post(`${config.API_URL}/laundry-nfsen-config`, data)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(STORE_NFSEN_CONFIG.SUCCESS, data))
        dispatch(showNfsenConfig())
        return data
      })
      .catch(e => dispatch(actionFailed(STORE_NFSEN_CONFIG, e)))
  }
}
